import { useEffect, useState } from 'react'

/**
 * Reactive hook returning true when the viewport matches the mobile breakpoint.
 * Uses matchMedia so it updates on viewport resize and device orientation changes.
 */
export function useIsMobile(query = '(max-width: 768px)') {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const onChange = (e) => setMatches(e.matches)
    setMatches(mql.matches)
    // addEventListener is the modern API; fall back to addListener for older Safari.
    if (mql.addEventListener) mql.addEventListener('change', onChange)
    else mql.addListener(onChange)
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange)
      else mql.removeListener(onChange)
    }
  }, [query])

  return matches
}

export default useIsMobile
